__turbopack_context__.v({
  "itemContainer": "_9xxiVG_itemContainer",
  "itemListContainer": "_9xxiVG_itemListContainer",
  "itemQuantity": "_9xxiVG_itemQuantity",
});
